import angular from 'angular';
import app from './app/app.module';
import auth from './auth/auth.module';

export default angular.module('app.components', [
  app,
  auth
]).name;



// WEBPACK FOOTER //
// ./components/components.module.js